import { render } from "./ProposalView.vue?vue&type=template&id=a3372c6e&scoped=true"
import script from "./ProposalView.vue?vue&type=script&lang=js"
export * from "./ProposalView.vue?vue&type=script&lang=js"

import "./ProposalView.vue?vue&type=style&index=0&id=a3372c6e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3372c6e"]])

export default __exports__